import axios from "axios";
import { CampaignResponseModel } from "../../../modules/campaign/models/campaignResponseModel";
import { CreateCampaignModel } from "../../../modules/createCampaign/models/createCampaignModel";
import { MediaType } from "../../enums/mediaTypes";
import { UserDataModel } from "../../models/userDataModel";

export const CampaignApi = () => {
  const userData: UserDataModel = JSON.parse(
    localStorage.getItem("techsauce-campaign-user-data") ?? "{}"
  );

  const realApi = axios.create({
    baseURL: "https://campaign.techsauce.co/api",
    timeout: 15000,
    headers: {
      Authorization: userData.token ?? "",
    },
  });
  return {
    campaigns: async () => {
      const result = await realApi.get("/campaigns");
      return result.data;
    },

    campaignBackground: async () => {
      const result = await realApi.get("/campaigns/backgrounds");
      return result.data;
    },

    newCampaignDesktopBackground: async (object?: {
      type: MediaType;
      value: string;
    }) => {
      const result = await realApi.post(
        "/campaigns/backgrounds/newDesktop",
        object
      );
      return result.data;
    },

    newCampaignMobileBackground: async (object?: {
      type: MediaType;
      value: string;
    }) => {
      const result = await realApi.post(
        "/campaigns/backgrounds/newMobile",
        object
      );
      return result.data;
    },

    createCampaign: async (data?: CreateCampaignModel) => {
      const result = await realApi.post(`/campaigns/create`, data);
      return result.data;
    },

    deleteCampaignBackground: async (id?: string) => {
      const result = await realApi.delete(`/campaigns/backgrounds/${id}`);
      return result.data;
    },

    toggleCampaignActive: async (id?: string) => {
      const result = await realApi.post(
        `/campaigns/${id}/toggleCampaignActive`
      );
      return result.data;
    },

    deleteCampaign: async (id?: string) => {
      const result = await realApi.delete(`/campaigns/${id}`);
      return result.data;
    },

    campaignDetail: async (id?: string) => {
      const result = await realApi.get(`/campaigns/${id}`);
      return result.data;
    },

    campaignDetailByPath: async (path?: string) => {
      const result = await realApi.get(`/campaigns/path/${path}`);
      return result.data;
    },

    submitCampaign: async (id?: string, response?: CampaignResponseModel) => {
      const result = await realApi.post(`/campaigns/${id}/submit`, response);
      return result.data;
    },

    campaignResult: async (id?: string) => {
      const result = await realApi.get(`/campaigns/${id}/result`);
      return result.data;
    },

    downloadResult: async (id?: string) => {
      const result = await realApi.get(`/campaigns/downloadResult/${id}`);
      return result.data;
    },
  };
};
